import {
  ALERTS_FETCH_SUCCESS,
  UPDATE_ALERT_SUCCESS,
  DELETE_ALERT_SUCCESS,
  UPDATE_ALERTS_CURRENT_PAGE,
  UPDATE_ALERTS_TOTAL_COUNT,
  UPDATE_ALERTS_TOTAL_PAGES
} from '../actionTypes';

let initialState = []

export function alerts(state = initialState, action) {
  switch(action.type) {
    case ALERTS_FETCH_SUCCESS:
      return action.payload;
    case UPDATE_ALERT_SUCCESS:
      return updateAlertsList(state, action.payload)
    case DELETE_ALERT_SUCCESS:
      return action.payload;
    default:
      return state;
  }
}

export function alertsCurrentPage(state = initialState, action) {
  switch(action.type) {
    case UPDATE_ALERTS_CURRENT_PAGE:
      return action.payload;
    default:
      return state;
  }
}

export function alertsTotalCount(state = initialState, action) {
  switch(action.type) {
    case UPDATE_ALERTS_TOTAL_COUNT:
      return action.payload;
    default:
      return state;
  }
}

export function alertsTotalPages(state = initialState, action) {
  switch(action.type) {
    case UPDATE_ALERTS_TOTAL_PAGES:
      return action.payload;
    default:
      return state;
  }
}

function updateAlertsList(state, payload) {
  return state.map(alert => {
    if (alert.id === payload.id) {
      return payload
    };
    return alert;
  });
}



// WEBPACK FOOTER //
// ./src/features/alertsManager/reducers/alerts.js